export const GoogleAdSenseBlock = ({ slotId }: { slotId: string }) => {
    return (
        <>
            <ins
                className="adsbygoogle"
                style={{ display: 'block' }}
                data-ad-client="ca-pub-2763822498467686"
                data-ad-format="auto"
                data-ad-slot={slotId}
                data-full-width-responsive="true"
            />
        </>
    );
};
